import { FieldRecord, FormPage } from "../FormTypes";
import { isQuestionBlock } from "./typePredicates";

export const getVisiblePages = (pages: FormPage[], fields: FieldRecord) => {
  return pages.filter(
    (page) =>
      page.page_type === "finish" ||
      page.blocks.some(
        (block) => isQuestionBlock(block) && fields[block.id].visible
      )
  );
};
